
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_240_5200)","fill":"#30A7CF"}},[_c('path',{attrs:{"d":"M6.922 16.52a.748.748 0 00-.845.394l-.75 1.5a.755.755 0 00.032.729c.14.222.38.357.64.357h.75a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.577-.73zM27.53 17.469l-1.5-1.499a.76.76 0 00-.34-.183.63.63 0 00-.093-.019c-.033-.003-.063-.018-.097-.018h-2.25a.75.75 0 000 1.5h1.5v1.5h-1.5a.75.75 0 000 1.5h2.25a.72.72 0 00.286-.058.728.728 0 00.245-.164l1.498-1.498a.75.75 0 000-1.061z"}}),_c('path',{attrs:{"d":"M35.826 22.02L32.475 18l3.35-4.02a.749.749 0 00-.575-1.23H31.5c-.2 0-.39.08-.531.219l-1.72 1.72-1.718-1.719a.75.75 0 00-.531-.22h-9.782a.748.748 0 00-.643.364l-1.607 2.68-1.606-2.68a.748.748 0 00-.644-.364H5.25a.751.751 0 00-.67.414l-4.5 9a.755.755 0 00.031.729c.138.222.38.357.64.357H4.5c.283 0 .542-.16.67-.414l.541-1.086H6v.75c0 .414.336.75.75.75h6a.75.75 0 00.736-.602l.094.188a.75.75 0 00.67.414h1.5c.284 0 .543-.16.671-.414l.095-.188a.75.75 0 00.735.602H27c.2 0 .39-.08.53-.219l1.72-1.719 1.719 1.72c.14.139.331.218.53.218h3.75a.75.75 0 00.577-1.23zm-16.356-.27H18V19.5a.75.75 0 00-1.422-.336l-1.292 2.586h-.575l-1.291-2.586A.75.75 0 0012 19.5v2.25H7.5V21a.75.75 0 00-.75-.75h-1.5a.751.751 0 00-.671.414l-.543 1.086H1.961l3.75-7.5H9v5.25a.75.75 0 001.5 0v-5.25h1.795l2.03 3.385c.27.452 1.018.452 1.286 0l2.034-3.385h1.826v7.5zm12.34.002v-.002l-2.03-2.031a.75.75 0 00-1.061 0l-2.03 2.031h-5.72v-7.5h5.72l2.031 2.031a.75.75 0 001.06 0l2.03-2.031h1.84l-2.725 3.27a.75.75 0 000 .962l2.724 3.27H31.81z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_240_5200"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h36v36H0z"}})])])])
          )
        }
      }
    